import Vue from 'vue'
import VueRouter from 'vue-router'
import LoginView from "@/views/LoginView";
import KazGateWay from "@/components/KazGateWay.vue";
import GateWayView from "@/views/GateWayView.vue";
import store from "@/store";

Vue.use(VueRouter)

const routes = [
    {
        path: '/login',
        name: "login",
        component: LoginView,
    },
    {
        path: '/',
        name: "GateWayView",
        component: GateWayView,
        meta: { requiresAuth: true },
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach((to, from, next) => {
    const isAuthenticated = store.getters['isAuthenticated'];

    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!isAuthenticated) {
            next('/login');
        } else {
            next();
        }
    } else {
        next();
    }
});
export default router
